import { useEffect } from 'react';
import { Radio, Input, Select } from 'antd';
import MapPortalService from '../../../services/MapPortal/mapportal.service';
import { useLayerProperitesContext } from '../../../context/LayerPropertiesContext';
import { useQuery } from '@tanstack/react-query';
import './LayerProperties.scss';

const { Option } = Select;

const FieldPropertiesTab = () => {
  const { fetchFeaturesKeyAndValueMapping } = MapPortalService();
  const { uniqueLayerName, fieldProperties, setState } = useLayerProperitesContext();
  const { data: features } = useQuery({
    ...fetchFeaturesKeyAndValueMapping(uniqueLayerName),
    enabled: !!uniqueLayerName && !fieldProperties?.length,
  });

  useEffect(() => {
    if (!features || fieldProperties?.length) return;

    const fields = Object.keys(features);

    const fp = fields.map((field) => ({
      field,
      alias: field,
      visibility: true,
      format: 'Auto Detect', //TODO: implement after PostGIS
    }));

    setState((prev) => ({
      ...prev,
      fieldProperties: fp,
    }));
    console.log('properties: ', fp);
  }, [features, fieldProperties?.length, setState]);

  return (
    <div>
      <h3 className="lp-tab__title--no-margin">FIELD PROPERTIES</h3>
      <div className="lp-fieldprops__header">
        <span>VISIBILITY</span>
        <span>FIELD</span>
        <span>ALIAS</span>
        <span>FORMAT</span>
      </div>
      {fieldProperties?.map((property, index) => (
        <div key={index} className={['lp-fieldprops__row', index % 2 === 0 ? 'lp-fieldprops__row--even' : 'lp-fieldprops__row--odd'].join(' ')}>
          <Radio
            checked={property.visibility}
            onClick={() =>
              setState((prev) => ({
                ...prev,
                fieldProperties: prev.fieldProperties?.map((prop, i) => (i === index ? { ...prop, visibility: !prop.visibility } : prop)),
              }))
            }
          />
          <span>{property.field}</span>
          <Input
            value={property.alias}
            onChange={(e) =>
              setState((prev) => ({
                ...prev,
                fieldProperties: prev.fieldProperties?.map((prop, i) => (i === index ? { ...prop, alias: e.target.value } : prop)),
              }))
            }
          />
          <Select
            value={property.format}
            onChange={(value) =>
              setState((prev) => ({
                ...prev,
                fieldProperties: prev.fieldProperties?.map((prop, i) => (i === index ? { ...prop, format: value } : prop)),
              }))
            }
          >
            <Option value="Auto Detect">Auto Detect</Option>
            <Option value="No formatting">No formatting</Option>
            <Option value="Whole Number">Whole Number</Option>
            <Option value="Date (MM-DD-YYYY)">MM-DD-YYYY</Option>
          </Select>
        </div>
      ))}
    </div>
  );
};

export default FieldPropertiesTab;
